import { Controller } from "@hotwired/stimulus"

const BATCH_SIZE = 20

// Normalise une chaine : lowercase + suppression des accents.
// "cassé" → "casse", "CACES" → "caces", "Chalon-sur-Saône" → "chalon-sur-saone"
function normalize(str) {
  return (str || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
}

export default class extends Controller {
  static targets = ["allDialog", "criticalDialog"]

  connect() {
    console.log("[sessions-modal] controller connected")
  }

  openAll(event) {
    event.preventDefault()
    this.show(this.allDialogTarget)
  }

  openCritical(event) {
    event.preventDefault()
    this.show(this.criticalDialogTarget)
  }

  close(event) {
    const dialog = event.target.closest("[data-sessions-modal-target]")
    if (dialog) this.hide(dialog)
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) this.close(event)
  }

  loadMore(event) {
    const dialog = event.target.closest("[data-sessions-modal-target]")
    if (!dialog) return

    const list = dialog.querySelector(".sessions-list")
    const query = normalize(dialog.querySelector(".sessions-search")?.value?.trim())
    const hidden = list.querySelectorAll(".session-item.hidden")
    let revealed = 0

    hidden.forEach((el) => {
      const searchable = normalize(el.dataset.searchText || el.textContent || "")
      const match = !query || searchable.includes(query)
      if (match && revealed < BATCH_SIZE) {
        el.classList.remove("hidden")
        revealed++
      }
    })

    this.updateCounter(dialog)
  }

  filter(event) {
    const dialog = event.target.closest("[data-sessions-modal-target]")
    if (!dialog) {
      console.warn("[sessions-modal] filter: no parent dialog found for input")
      return
    }

    const query = normalize(event.target.value.trim())
    const items = dialog.querySelectorAll(".session-item")
    console.log(`[sessions-modal] filter: query="${query}", items=${items.length}`)

    if (!query) {
      this.resetItems(dialog)
      return
    }

    let visible = 0
    items.forEach((el) => {
      const searchable = normalize(el.dataset.searchText || el.textContent || "")
      if (searchable.includes(query)) {
        el.classList.remove("hidden")
        visible++
      } else {
        el.classList.add("hidden")
      }
    })

    console.log(`[sessions-modal] filter: ${visible} matches`)
    this.updateCounter(dialog)
  }

  show(dialog) {
    this.resetItems(dialog)
    dialog.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hide(dialog) {
    dialog.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  resetItems(dialog) {
    const items = dialog.querySelectorAll(".session-item")
    items.forEach((el, index) => {
      if (index >= BATCH_SIZE) {
        el.classList.add("hidden")
      } else {
        el.classList.remove("hidden")
      }
    })
    this.updateCounter(dialog)
  }

  updateCounter(dialog) {
    const total = dialog.querySelectorAll(".session-item").length
    const stillHidden = dialog.querySelectorAll(".session-item.hidden").length
    const visible = total - stillHidden

    const counter = dialog.querySelector(".sessions-visible-count")
    if (counter) counter.textContent = visible

    const btn = dialog.querySelector(".sessions-load-more-btn")
    if (btn) {
      btn.classList.toggle("hidden", stillHidden === 0)
    }
  }
}
